/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

// gatsby-browser.js
import React from 'react'
import fetch from 'cross-fetch'
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloProvider,
} from '@apollo/client'
import { LanguageProvider, langFromPath } from './src/context/LanguageContext'
const cache = new InMemoryCache()
const link = new HttpLink({
  /* Set the endpoint for your GraphQL server, (same as in gatsby-config.js) */
  uri: process.env.GATSBY_SOURCE_WORDPRESS_URL,
  /* Use fetch from cross-fetch to provide replacement for server environment */
  fetch,
})
const client = new ApolloClient({
  link,
  cache,
})
export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
)

// Gives every page its language ('sv' or 'en')
export const wrapPageElement = ({ element, props }) => (
  <LanguageProvider
    lang={props.pageContext?.lang || langFromPath(props.location?.pathname)}
    altPath={props.pageContext?.altPath}
  >
    {element}
  </LanguageProvider>
)

// Keep <html lang> right when navigating between languages without a reload
export const onRouteUpdate = ({ location }) => {
  document.documentElement.lang = langFromPath(location.pathname)
}
